import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {createDismissibleBanner} from '../../../../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {cyrb53} from '../../../../util/hash';
import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../../Banner';
import {globalRegistryType} from '../../common/utils';
import {useGetMigratedRegistryEntityInfo} from '../hooks';

export type SDKVersionWarningBannerProps = {
  registry: globalRegistryType;
  userID: string;
};

export const SDKVersionWarningBanner =
  createDismissibleBanner<SDKVersionWarningBannerProps>({
    id: ({registry, userID}) =>
      cyrb53(registry.registryProjectInternalId + ':' + userID).toString() +
      ':sdk-version-warning',
    Component: ({registry, onDismiss}) => {
      // Fetch the team name, whose legacy model registry was migrated
      const {isMigratedRegistryProject} = useGetMigratedRegistryEntityInfo(
        registry.entityName,
        registry.registryProjectName
      );
      if (!isMigratedRegistryProject) {
        return null;
      }
      return (
        <Tailwind>
          <Banner
            data-test="mr-migration-sdk-version-warning"
            variant={'announcement'}
            className="my-16">
            <BannerFlexWrapper>
              <div>
                <Icon name="lightbulb-info" />
              </div>
              <BannerTextWrapper className="px-12">
                <span>
                  <BannerBoldText>
                    To ensure accurate SDK results, please upgrade to v0.21.0 or
                    later.{' '}
                  </BannerBoldText>
                  We automatically reroute most calls to the new registry, but
                  older SDKs may not reflect this — in those cases, you'll
                  receive outdated data from the legacy registry.
                </span>
              </BannerTextWrapper>
            </BannerFlexWrapper>
            {/*TODO: Add a `Learn more` button that redirects to the docs */}
            <button
              className="flex items-center border-none bg-transparent font-semibold text-moon-800 hover:cursor-pointer hover:text-moon-950"
              onClick={() => {
                onDismiss();
              }}>
              <Icon name="close" />
            </button>
          </Banner>
        </Tailwind>
      );
    },
  });
